import { useMemo } from 'react';

import { StreamApprovalInfoTypeFragment, useStreamApprovalLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useStreamApproval = () => {
  const [query, queryResult] = useStreamApprovalLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const request = async (id: string) => {
    const result = await query({
      variables: {
        id,
      },
    });

    return result;
  };

  const stream: StreamApprovalInfoTypeFragment | undefined = queryResult?.data?.result || undefined;

  return useMemo(
    () => ({
      loading: queryResult?.loading,
      called: queryResult?.called,
      error: queryResult?.error,
      request,
      stream,
    }),
    [stream, queryResult?.loading, queryResult?.error]
  );
};

export default useStreamApproval;
